// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ProductDescription_description-container__8sDV5 .ProductDescription_section-title__4kqCX {
  margin: 16px 0px 8px;
  font-size: 20px;
  font-weight: bold;
  text-transform: initial;
}
.ProductDescription_description-container__8sDV5 .ProductDescription_section-title__4kqCX:first-letter {
  text-transform: uppercase;
}
.ProductDescription_description-container__8sDV5 .ProductDescription_description__cmHbx {
  margin-bottom: 60px;
}
.ProductDescription_description-container__8sDV5 .ProductDescription_description__cmHbx .ProductDescription_section-content__q7SKQ {
  font-size: 16px;
  line-height: 24px;
}
.ProductDescription_description-container__8sDV5 .ProductDescription_description__cmHbx .ProductDescription_section-content__q7SKQ .ProductDescription_description-list__ipggu {
  padding-left: 24px;
}
.ProductDescription_description-container__8sDV5 .ProductDescription_description__cmHbx .ProductDescription_section-content__q7SKQ .ProductDescription_list-item__6hukK {
  line-height: 24px;
}`, "",{"version":3,"sources":["webpack://./src/views/ProductDetailView/ProductDescription/ProductDescription.module.scss","webpack://./src/styles/_typography.scss"],"names":[],"mappings":"AAEE;EACE,oBAAA;EACA,eAAA;EACA,iBCEG;EDDH,uBAAA;AADJ;AAGE;EACE,yBAAA;AADJ;AAGE;EACE,mBAAA;AADJ;AAEI;EACE,eCZG;EDaH,iBAAA;AAAN;AACM;EACE,kBAAA;AACR;AACM;EACE,iBAAA;AACR","sourcesContent":["@use \"styles/typography\";\n.description-container {\n  .section-title {\n    margin: 16px 0px 8px;\n    font-size: typography.$header-s;\n    font-weight: typography.$bold;\n    text-transform: initial;\n  }\n  .section-title:first-letter {\n    text-transform: uppercase;\n  }\n  .description {\n    margin-bottom: 60px;\n    .section-content {\n      font-size: typography.$body-l;\n      line-height: 24px;\n      .description-list {\n        padding-left: 24px;\n      }\n      .list-item {\n        line-height: 24px;\n      }\n    }\n  }\n}\n","$body-s: 12px;\n$body-m: 14px;\n$body-l: 16px;\n$header-xs: 18px;\n$header-s: 20px;\n$header-m: 24px;\n$header-l: 34px;\n$bold: bold;\n$semi-bold: 600;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"description-container": `ProductDescription_description-container__8sDV5`,
	"section-title": `ProductDescription_section-title__4kqCX`,
	"description": `ProductDescription_description__cmHbx`,
	"section-content": `ProductDescription_section-content__q7SKQ`,
	"description-list": `ProductDescription_description-list__ipggu`,
	"list-item": `ProductDescription_list-item__6hukK`
};
export default ___CSS_LOADER_EXPORT___;
